const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the users tracks status component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Certificates} Certificates the resource defined to manage Certificates
 */
app.directive('userCertificates', ['Authorization', 'Certificates', function (Authorization, Certificates) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/user-certificates.html'),
      controller: function () {
        var self = this;
        self.user = Authorization.getAuthToken().user;
        self.translations = {};
        moment.locale(self.user.language);

        self.closeCertificate = function() {
          self.showCertificate = false;
        };

        self.viewCert = function(item) {
          self.activeCert = item;
          self.showCertificate = true;
        };

        self.formatDate = function(date) {
          return moment(date).format('MMMM Do, YYYY');
        };

        self.initialize = function() {
          self.loading = true;
          Certificates.userCertificates({subresource: self.user._id}).$promise
          .then(function(certs) {
            self.loading = false;
            self.certs = certs;
            self.loaded = true;
          });
        };

        self.initialize();

      },
      controllerAs: 'userCert'
    };
  }]);
